import React from 'react'
import { AccountContext } from './AccountProvider';

export default function useAccount() {
    return React.useContext(AccountContext);
}
